var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// import "./account.css";
import React, { useEffect, useState } from "react";
import { ApiService } from "../../services/http.service";
import { modalServiceSubject } from "../../services/modal.service";
import { env } from "../../constants/global.constants";
import { useNavigate } from "react-router-dom";
var platformMapping = {
    0: "Web",
    1: "Mobil",
    2: "Bilinmeyen",
};
export function AccountSessions() {
    var _this = this;
    var _a = useState([]), sessions = _a[0], setSessions = _a[1];
    var navigate = useNavigate();
    var getSessions = function () { return __awaiter(_this, void 0, void 0, function () {
        var api, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    api = new ApiService();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.start("get", env.accounting_api + "/member/api/handle-member-session/", {}, true)];
                case 2:
                    response = _a.sent();
                    setSessions(response.data);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var closeSession = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var api;
        return __generator(this, function (_a) {
            api = new ApiService();
            try {
                modalServiceSubject.next({
                    title: "Emin misiniz?",
                    content: "Bu oturumunuzu kapatmak istedi\u011Finize emin misiniz?",
                    confirm: {
                        sure: {
                            class: "btn-danger fs-7 fw-semibold",
                            label: "Evet",
                            action: function () {
                                api
                                    .start("post", env.accounting_api + "/member/api/handle-member-session/", { id: id.toString() }, true)
                                    .then(function (res) {
                                    if (res.status) {
                                        getSessions();
                                        navigate(0);
                                    }
                                    else {
                                        modalServiceSubject.next({
                                            title: "Hata",
                                            content: res.message,
                                            timeout: 3000,
                                        });
                                    }
                                });
                            },
                        },
                        cancel: {
                            class: "btn-secondary fs-7 fw-semibold",
                            label: "Vazgeç",
                        },
                    },
                });
            }
            catch (error) {
                console.error(error);
            }
            return [2 /*return*/];
        });
    }); };
    var closeAllSessions = function () {
        var api = new ApiService();
        try {
            var activeSessionIds_1 = sessions
                .filter(function (session) { return !isSessionExpired(session.expiry_date); })
                .map(function (session) { return session.id; })
                .join(",");
            if (activeSessionIds_1) {
                modalServiceSubject.next({
                    title: "Emin misiniz?",
                    content: "T\u00FCm oturumlar\u0131n\u0131z\u0131 kapatmak istedi\u011Finize emin misiniz?",
                    confirm: {
                        sure: {
                            class: "btn-danger fs-7 fw-semibold",
                            label: "Evet",
                            action: function () {
                                api
                                    .start("post", env.accounting_api + "/member/api/handle-member-session/", { id: activeSessionIds_1 }, true)
                                    .then(function (res) {
                                    if (res.status) {
                                        getSessions();
                                        navigate(0);
                                    }
                                    else {
                                        modalServiceSubject.next({
                                            title: "Hata",
                                            content: res.message,
                                            timeout: 3000,
                                        });
                                    }
                                });
                            },
                        },
                        cancel: {
                            class: "btn-secondary fs-7 fw-semibold",
                            label: "Vazgeç",
                        },
                    },
                });
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    var isSessionExpired = function (expiry_date) {
        return new Date(expiry_date) < new Date();
    };
    useEffect(function () {
        getSessions();
    }, []);
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "row mt-3" }, { children: _jsx("div", __assign({ className: "col-12 col-mobile-12" }, { children: _jsxs("div", __assign({ className: "card rounded-4 mb-4" }, { children: [_jsx("div", __assign({ className: "card-header" }, { children: _jsx("h2", { children: "Oturumlar\u0131m" }) })), _jsxs("div", __assign({ className: "card-body mobile-scroll" }, { children: [_jsxs("table", __assign({ className: "table table-striped" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Platform" }), _jsx("th", { children: "Detay" }), _jsx("th", { children: "Son Giri\u015F" }), _jsx("th", __assign({ style: { width: 110 }, className: "text-center" }, { children: "\u0130\u015Flem" }))] }) }), _jsx("tbody", { children: sessions.length > 0 ? (sessions.map(function (session, index) { return (_jsx(React.Fragment, { children: _jsxs("tr", { children: [_jsx("td", __assign({ className: "fw-semibold" }, { children: session.platform })), _jsxs("td", __assign({ className: "fw-semibold tooltip", style: {
                                                                maxWidth: "200px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            } }, { children: [session.platform_detail, _jsx("span", __assign({ className: "tooltip-text" }, { children: session.platform_detail }))] })), _jsx("td", { children: new Date(session.create_date).toLocaleString() }), _jsx("td", __assign({ className: "text-center" }, { children: _jsx("button", __assign({ className: "btn btn-danger btn-sm fw-semibold fs-7", onClick: function () { return closeSession(session.id); }, disabled: isSessionExpired(session.expiry_date) }, { children: "Oturumu Kapat" })) }))] }) }, "session-".concat(index))); })) : (_jsx("tr", { children: _jsx("td", __assign({ colSpan: 3, className: "text-center" }, { children: _jsx("p", __assign({ className: "fs-7" }, { children: "Hen\u00FCz oturum bilgisi bulunmamaktad\u0131r." })) })) })) })] })), sessions.length > 0 && (_jsx("div", __assign({ className: "text-center mt-3" }, { children: _jsx("button", __assign({ className: "btn btn-sm btn-danger fw-semibold fs-7", onClick: closeAllSessions }, { children: "T\u00FCm Oturumlar\u0131 Kapat" })) })))] }))] })) })) })) }));
}
